import { Box, Grid, Typography } from "@mui/material";
import { HashLink as Link } from "react-router-hash-link";
import List from "../components/list";

import Section from "../components/Section";
import SubTitleHeader from "../components/SubTitle";
import FrequentlyAskedQuestionsView from "./components/FrequentlyAskedQuestionsView";
import {
  atTheFestQuestions,
  generalQuestions,
  otherQuestions,
} from "./components/questions";
import GettingHereScreen from "./GettingHereScreen";

export const textDecoration = {
  textDecorationColor: "#f1dd84",
  textDecoration: "none",
};

export const linkStyles = { color: "yellow.main" };
const FestivalInformationScreen = () => {
  return (
    <Box>
      <Section title="Festival Info">
        <Grid item xs={12}>
          <SubTitleHeader subTitle="General Info" />
        </Grid>
        <Typography
          sx={{
            fontSize: 16,
            marginBottom: "8px",
          }}
          color="primary"
        >
          Amplitude is small attendee-run festival that will be held in Eastern Washington
          (2.5 hours from Seattle), with the backdrop of some absolutely breathtaking views of the Columbia
          River Gorge. The event will consist of activities and DJ sets during the day, followed by DJ sets
          at night. It is an entirely attendee-run event. All attendees are encouraged to bring their own
          activity, music, and/or art. We're striving to make Amplitude a fun stop on the journey through
          a wonderful festival season.
        </Typography>

        <SubTitleHeader subTitle="Jump to an offering…" />
        <Grid sx={{ marginBottom: "10px" }}>
          <Link to={"#GettingHere"} style={textDecoration}>
            <Typography sx={linkStyles}>Getting Here</Typography>
          </Link>
          <Link to={"#WhatToExpect"} style={textDecoration}>
            <Typography sx={linkStyles}>What To Expect</Typography>
          </Link>
          <Link to={"#FAQ"} style={textDecoration}>
            <Typography sx={linkStyles}>Frequently Asked Questions</Typography>
          </Link>
        </Grid>
      </Section>
      {/* Getting Here */}
      <Section>
        <Grid container>
          <Grid item container xs={12}>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12}>
                <SubTitleHeader anchor="GettingHere" subTitle="Getting Here" />
              </Grid>
              <GettingHereScreen />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12}>
                <SubTitleHeader subTitle="Gate Info" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    paddingRight: { xs: "10px", sm: "40px", md: "100px" },
                  }}
                  color="primary"
                  paragraph
                >
                  Gate will be open on Friday from 4pm - 12am, and 
                  Saturday from 1pm - 7pm. Your campsite must be clean and empty by
                  3:30pm on Sunday.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    paddingRight: { xs: "10px", sm: "40px", md: "100px" },
                  }}
                  color="primary"
                  paragraph
                >
                  Gate Hours:
                </Typography>
                <List
                  items={[
                    "Friday: 4pm-12am",
                    "Saturday: 1pm-7pm",
                    "Sunday: MUST LEAVE BY 3:30PM",
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Section>
      {/* What to expect */}
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="WhatToExpect" subTitle="What To Expect" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <List
              items={[
                "Each campsite has plenty of fresh grass for setting up on.",
                "The venue has trailer toilets and showers, showers will have limited hours. There is no electricity in the campgrounds, so please plan accordingly.",
                "Potable water is available in the bathrooms and sinks throughout the venue. Ice is available for purchase inside the venue from 11am - 12pm and 5pm - 6pm Saturday ($10 cash or $13 Venmo per 20lb bag).",
                "Weather during July can be unpredictable. Daytime temperatures range from 80 to 110 °F and nighttime temperatures can drop drastically. Prepare to have fun, rain or shine!",
                "We'll have programming from 4pm - 4am on Friday, and noon to 4am on Saturday",
                "The campground is tiered with different elevations for each tier, and one tier will be where all of our programming takes place. All attendee camping is either downhill or uphill from the main event areas - when you're ready to enjoy the programming for a few hours straight we suggest bringing everything you'll need to avoid many long round trip walks to and from camp.",
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <SubTitleHeader anchor="Arrival" subTitle="Arrival" />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginBottom: "20px",
              paddingBottom: "20px",
              borderBottom: 2,
              borderColor: "teal.dark",
            }}
          >
            <List
              items={[
                "Parking is charged per vehicle (one per campsite) and valid for the entire weekend. Vehicles are allowed in-and-out privileges during gate hours. Please carpool!",
                "Once all tickets have been scanned at the gate venue staff will escort your vehicle to a campsite"
              ]}
            />
          </Grid>
          <Grid container item xs={12}>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12}>
                <SubTitleHeader subTitle="Bring It With You" />
              </Grid>
              <Grid item xs={12}>
                <List
                  items={[
                    "Hiking boots for uneven ground",
                    "Sunscreen, sun glasses, sun hat, camp shade",
                    "Water bottle & hydration pack",
                    "Electrolytes",
                    "Camping gear (tent, tarp, sleeping bags, etc.)",
                    "Camp chair",
                    "Lantern/flashlight/headlamp with extra batteries",
                    "Cooler",
                    "Personal fan",
                    "All food and drinks for the weekend - potable water available",
                    "Neck gaiter for dust",
                    "Rain gear",
                    "Warm Hoodies, long underwear, leggings, hat",
                    "Towel & Sandals",
                    "Soap & Shampoo",
                    "Earplugs",
                  ]}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid item xs={12}>
                <SubTitleHeader subTitle="Leave it at Home" />
              </Grid>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <List
                    items={[
                      "No pets (dogs, cats, etc.)",
                      "No drones (unless you have explicit written permission from festival organizers)",
                      "No fireworks",
                      "No weapons",
                      "No gas, wood, or charcoal grills (small propane camping stoves are okay on the gravel)",
                      "No personal motorized vehicles (including scooters, ATVs, powered skateboards, etc.)",
                      "No natural wood fire pits, fires, or candles",
                      "No illegal drugs, substances, or paraphernalia of any kind",
                      "No pools or kiddie pools",
                      "No kegs, mini-kegs, or binge-drinking devices",
                    ]}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Section>
      {/* FAQ */}
      <Section>
        <Grid container>
          <Grid item xs={12}>
            <SubTitleHeader anchor="FAQ" subTitle="FAQ" />
          </Grid>

          <FrequentlyAskedQuestionsView
            questions={generalQuestions}
            subTitle="General"
          />

          <FrequentlyAskedQuestionsView
            questions={atTheFestQuestions}
            subTitle="At the Fest"
          />

          <FrequentlyAskedQuestionsView
            questions={otherQuestions}
            subTitle="Other Questions"
          />
        </Grid>
      </Section>
    </Box>
  );
};

export default FestivalInformationScreen;
